import axios from "axios";
import Cookies from "js-cookie";

const instance = axios.create({
  baseURL: process.env.REACT_APP_BACKEND_URL,
  withCredentials: true,
});

const batchUpConsumerInstance = axios.create({
  baseURL: process.env.REACT_APP_BACKEND_BATCH_UP_CONSUMER_URL,
  withCredentials: true,
});

export const GET = async (path: string, header?: any) => {
  const config = {
    headers: { Authorization: `Bearer ${Cookies.get("jwt")}` },
  };

  try {
    const response = await instance.get(`/${path}`, header ? header : config);
    const data = await response.data;
    return data;
  } catch (error: any) {
    console.error(error.response);
    throw error.response;
  }
};

export const GET2 = async (path: string, header?: any) => {
  const config = {
    headers: { Authorization: `Bearer ${Cookies.get("jwt")}` },
  };

  try {
    const response = await axios.get(path, header ? header : config);
    return response.data; // Return the data if available
  } catch (error: any) {
    console.error(error.response);
    throw error.response; // Rethrow the error for further handling
  }
};

export const GETV2 = async (path: string, header?: any, isBlob = false) => {
  const baseConfig = {
    headers: { Authorization: `Bearer ${Cookies.get("jwt")}` },
    responseType: isBlob ? "blob" : "json",
  };

  const config = header ? { ...baseConfig, ...header } : baseConfig;
  try {
    const response = await instance.get(`/${path}`, config);
    const data = response.data;
    if (data?.success === false) {
      throw data;
    }

    return data;
  } catch (error: unknown) {
    if (axios.isAxiosError(error)) {
      throw (
        error.response?.data ?? {
          message: "Network error",
        }
      );
    }

    throw error;
  }
};

export const GET_BATCH_UP_CONSUMER = async (path: string, header?: any) => {
  const config = {
    headers: { Authorization: `Bearer ${Cookies.get("jwt")}` },
  };

  try {
    const response = await batchUpConsumerInstance.get(`/${path}`, header ? header : config);
    const data = await response.data;
    return data;
  } catch (error: any) {
    console.error(error.response);
    throw error.response;
  }
};

export const DELETE = async (path: string, data: any) => {
  try {
    const response = await instance.delete(`/${path}`, {
      headers: { Authorization: `Bearer ${Cookies.get("jwt")}` },
      data,
    });

    data = await response.data;
    return data;
  } catch (error: any) {
    console.error(error.response);
    throw error.response;
  }
};

export const POST = async (path: string, data: any, header?: any) => {
  const config = {
    headers: { Authorization: `Bearer ${Cookies.get("jwt")}` },
  };

  try {
    const response = await instance.post(`/${path}`, data, header ?? config);
    data = await response.data;
    return data;
  } catch (error: any) {
    throw error.response;
  }
};

export const POSTV2 = async (path: string, data: any, header?: any) => {
  const config = {
    headers: { Authorization: `Bearer ${Cookies.get("jwt")}` },
  };

  try {
    const response = await instance.post(`/${path}`, data, header ?? config);
    data = await response.data;
    return data;
  } catch (error: any) {
    console.log("ssss", error);
    if (axios.isAxiosError(error)) {
      throw (
        error.response?.data ?? {
          message: "Network error",
        }
      );
    }

    throw error;
  }
};

export const PUT = async (path: string, data: any, header?: any) => {
  const config = {
    headers: { Authorization: `Bearer ${Cookies.get("jwt")}` },
  };

  try {
    const response = await instance.put(`/${path}`, data, header ? header : config);
    data = await response.data;
    return data;
  } catch (error: any) {
    throw error.response;
  }
};

export const PATCH = async (path: string, data: any) => {
  const config = {
    headers: { Authorization: `Bearer ${Cookies.get("jwt")}` },
  };

  try {
    const response = await instance.patch(`/${path}`, data, config);
    data = await response.data;
    return data;
  } catch (error: any) {
    throw error.response;
  }
};

export const PATCH2 = (path: string, data: any) => {
  const config = {
    headers: { Authorization: `Bearer ${Cookies.get("jwt")}` },
  };

  instance.patch(`/${path}`, data, config).catch((error) => {
    console.error("Error in PATCH request:", error.response);
  });
};

export const PATCH_BATCH_UP_CONSUMER = async (path: string, data: any) => {
  const config = {
    headers: { Authorization: `Bearer ${Cookies.get("jwt")}` },
  };

  try {
    const response = await batchUpConsumerInstance.patch(`/${path}`, data, config);
    data = await response.data;
    return data;
  } catch (error: any) {
    throw error.response;
  }
};
